import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconMagnify = t0 => {
  const $ = _c(7);
  const {
    className: t1,
    color: t2,
    height: t3,
    width: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const color = t2 === undefined ? colorGray : t2;
  const height = t3 === undefined ? 16 : t3;
  const width = t4 === undefined ? 16 : t4;
  let t5;
  if ($[0] !== color) {
    t5 = <path clipRule="evenodd" d="M15.059 15.6834L11.1943 12.6711C10.0574 13.5236 8.58063 14.035 7.04628 14.035C3.18163 14.035 0 10.9098 0 6.98873C0 3.0687 3.18272 0 7.04737 0C10.9109 0 14.0937 3.18272 14.0937 7.04628C14.0937 8.9216 13.3553 10.6829 12.1043 11.9338L15.7985 14.7756L15.059 15.6834ZM7.04738 12.9567C10.2866 12.9567 12.9578 10.343 12.9578 7.04627C12.9568 3.75062 10.2866 1.1369 7.04738 1.1369C3.80819 1.1369 1.13692 3.80711 1.13692 7.04627C1.13692 10.2854 3.80819 12.9567 7.04738 12.9567ZM7.5 6.5H10.1667V7.43333H7.5V10.1667H6.5V7.43333H3.83333V6.5H6.5V3.83333H7.5V6.5Z" fill={color} fillRule="evenodd" />;
    $[0] = color;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== className || $[3] !== height || $[4] !== t5 || $[5] !== width) {
    t6 = <svg className={className} fill="none" height={height} viewBox="0 0 16 16" width={width}>{t5}</svg>;
    $[2] = className;
    $[3] = height;
    $[4] = t5;
    $[5] = width;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
IconMagnify.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};
export default IconMagnify;